<template>
  <div  v-loading="talentLoading" style="min-height: 200px">
    <div v-if="achData && achData.length && !talentLoading">
    <div class="person-item" v-for="(item,i) in achData" :key="i" @click="toPaperDetail(item.id)">
      <div style="margin-left: 8px">
        <div class="person-name">{{ item.title }}</div>
        <div class="item-left flex-wrap" style="width: 100%">
          <label class="no-wrap">作者：</label>
          <span
            class="item-right" style="margin-right: 9px;flex-shrink: 0"
            v-for="(auther,index) in item.authors.length > 3 ? item.authors.slice(0,3):item.authors"
            :key="index"
            :title="auther.scholarName"
          >
            <el-avatar fit="cover" :size="14" :src="auther.avatarUrl" @error="errorHandler">
              <img src="https://cube.elemecdn.com/e/fd/0fc7d20532fdaf769a25683617711png.png" />
            </el-avatar>
            {{ auther.scholarName }}
          </span>
        </div>
        <div class="item-left ellipsis">
          <label>出版物：</label>
          <span class="item-right ellipsis">{{ item.venue || '-' }}</span>
        </div>
        <div class="item-left ellipsis">
          <label>引用次数：</label><span class="item-right ellipsis" style="margin-right: 9px">{{ item.citationNum || 0  }}</span>
          <label>发表时间：</label><span class="item-right ellipsis">{{ item.year || '-'  }}</span>
        </div>
      </div>
    </div>
    </div>
    <el-empty v-else></el-empty>
  </div>
</template>

<script>

// import { getAchievementPaperApi } from '@/api/search';

export default {
  name: 'paperList',
  components: {},
  props: ["achData",'talentLoading'],
  data() {
    return {
    };
  },
  created() {
  },
  methods: {
    // 跳转论文详情
    toPaperDetail(id) {
      let obj = {
        name: 'paperDetail',
        query: { id },
      };
      let routeData = this.$router.resolve(obj);
      window.open(routeData.href, '_blank');
    },
    errorHandler() {
      return true;
    }
  },
  watch: {}
};
</script>

<style scoped lang="less">

.person-item {
  margin: 5px 19px;
  display: flex;
  cursor: pointer;
  padding: 15px;
  background: #FFFFFF;
  border-radius: 4px;
  border: 1px solid #DEE2E9;

  .person-name {
    font-weight: 500;
    line-height: 26px;
    font-size: 18px;
    color: #181F33;
  }

  .item-left {
    display: flex;
    max-width: 280px;
    line-height: 24px;
    align-items: center;
    margin-top: 11px;
    font-size: 14px;
    color: #8191B2;
    label {
      color: #8191B2;
      white-space: nowrap;
    }
  }

  .item-right {
    font-size: 14px;
    color: #50607F;
  }

  .item-num {
    font-size: 14px;
    color: #3860F4;
    margin-left: 4px;
  }
}

</style>
